import styled from "styled-components";

export const LogoDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  flex-direction: column;
`;

export const Logo = styled.h1`
  font-family: "Racing Sans One";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  user-select: none;
  letter-spacing: 1px;
`;
